import { useState } from 'react';

interface Props {
  value: number;
  isMobile: boolean;
}
const useGaugeValue = ({ value, isMobile }: Props) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  const formattedNumber = +formatter.format(value);

  const calculateRotation = (): string => {
    const gaugeAngles: { [x: number]: number } = gaugeAngleValues;

    return `rotate(${gaugeAngles[formattedNumber]}deg)`; // Return the rotation as a CSS transform value
  };

  const calculateShadow = (): string => {
    const shadowPercentatge: { [x: number]: number } = {
      0: 123,
      1: 123,
      2: 123,
      3: 123,
      4: 123,
      5: 123,
      6: 123,
      7: 123,
      8: 123,
      9: 123,
      10: 122.5,
      11: 122,
      12: 121.5,
      13: 120,
      14: 119,
      15: 118.5,
      16: 118,
      17: 117,
      18: 117,
      19: 117,
      20: 117,
      21: 117,
      22: 117,
      23: 117,
      24: 117,
      25: 117,
    };

    const lessRotationNeeded = 13;

    return `${
      isMobile ? shadowPercentatge[formattedNumber] - lessRotationNeeded : shadowPercentatge[formattedNumber]
    }%`;
  };

  const RotationValues = {
    GAUGE: calculateRotation(),
    SHADOW: calculateShadow(),
  };

  return {
    RotationValues,
  };
};

export default useGaugeValue;

const gaugeAngleValues: { [x: number]: number } = {
  0: 0,
  0.1: 1,
  0.2: 2,
  0.3: 3,
  0.4: 4,
  0.5: 5.5,
  0.6: 6,
  0.7: 6.5,
  0.8: 7,
  0.9: 7.5,
  1: 8,
  1.1: 9,
  1.2: 9.5,
  1.3: 10,
  1.4: 10.5,
  1.5: 11,
  1.6: 12,
  1.7: 13,
  1.8: 14,
  1.9: 15,
  2: 16,
  2.1: 16.5,
  2.2: 17,
  2.3: 17.5,
  2.4: 18,
  2.5: 19,
  2.6: 20,
  2.7: 21,
  2.8: 22,
  2.9: 23,
  3: 24,
  3.1: 24.5,
  3.2: 25,
  3.3: 25.5,
  3.4: 26,
  3.5: 27,
  3.6: 28,
  3.7: 29,
  3.8: 30,
  3.9: 31,
  4: 32,
  4.1: 32.5,
  4.2: 33,
  4.3: 33.5,
  4.4: 34,
  4.5: 35,
  4.6: 36,
  4.7: 37,
  4.8: 38,
  4.9: 39,
  5: 40,
  5.1: 41,
  5.2: 42,
  5.3: 43,
  5.4: 44,
  5.5: 45,
  5.6: 46,
  5.7: 47,
  5.8: 48,
  5.9: 49,
  6: 50,
  6.1: 50.5,
  6.2: 51,
  6.3: 52,
  6.4: 53,
  6.5: 54,
  6.6: 55,
  6.7: 56,
  6.8: 57,
  6.9: 58,
  7: 59,
  7.1: 60,
  7.2: 61,
  7.3: 62,
  7.4: 63.5,
  7.5: 65,
  7.6: 66,
  7.7: 67,
  7.8: 68,
  7.9: 70,
  8: 72,
  8.1: 72.5,
  8.2: 73,
  8.3: 73.5,
  8.4: 74.5,
  8.5: 75.5,
  8.6: 76,
  8.7: 77,
  8.8: 78,
  8.9: 79,
  9: 80,
  9.1: 81,
  9.2: 82,
  9.3: 83,
  9.4: 84,
  9.5: 85,
  9.6: 86,
  9.7: 87,
  9.8: 88,
  9.9: 89,
  10: 91,
  10.1: 92,
  10.2: 94,
  10.3: 95,
  10.4: 96,
  10.5: 97,
  10.6: 98,
  10.7: 99,
  10.8: 99.5,
  10.9: 100,
  11: 101,
  11.1: 102,
  11.2: 103,
  11.3: 104,
  11.4: 105,
  11.5: 106,
  11.6: 107,
  11.7: 108,
  11.8: 109,
  11.9: 110,
  12: 112,
  12.1: 113,
  12.2: 114,
  12.3: 115,
  12.4: 116,
  12.5: 117.5,
  12.6: 118.5,
  12.7: 119.5,
  12.8: 121,
  12.9: 122,
  13: 123,
  13.1: 124,
  13.2: 125,
  13.3: 126,
  13.4: 127,
  13.5: 128.5,
  13.6: 129.5,
  13.7: 131,
  13.8: 132,
  13.9: 133,
  14: 134,
  14.1: 135,
  14.2: 136,
  14.3: 137,
  14.4: 138.5,
  14.5: 140,
  14.6: 142,
  14.7: 143,
  14.8: 144,
  14.9: 145,
  15: 146,
  15.1: 147,
  15.2: 148,
  15.3: 149,
  15.4: 150,
  15.5: 151,
  15.6: 152,
  15.7: 153,
  15.8: 154,
  15.9: 155,
  16: 156,
  16.1: 157,
  16.2: 158,
  16.3: 159,
  16.4: 160,
  16.5: 161,
  16.6: 162,
  16.7: 163,
  16.8: 164,
  16.9: 165,
  17: 168,
  17.1: 169,
  17.2: 171,
  17.3: 172,
  17.4: 173,
  17.5: 174,
  17.6: 175,
  17.7: 176,
  17.8: 177,
  17.9: 178,
  18: 180,
  18.1: 181,
  18.2: 182,
  18.3: 183,
  18.4: 184,
  18.5: 185,
  18.6: 185,
  18.7: 187,
  18.8: 187.5,
  18.9: 188,
  19: 189,
  19.1: 190,
  19.2: 191,
  19.3: 192,
  19.4: 192.5,
  19.5: 193,
  19.6: 193.5,
  19.7: 194,
  19.8: 195,
  19.9: 197,
  20: 199,
  20.1: 201,
  20.2: 202,
  20.3: 203,
  20.4: 204,
  20.5: 205,
  20.6: 206,
  20.7: 207,
  20.8: 208,
  20.9: 209,
  21: 210,
  21.1: 211,
  21.2: 212,
  21.3: 213,
  21.4: 214,
  21.5: 215,
  21.6: 216,
  21.7: 217,
  21.8: 218,
  21.9: 219,
  22: 220,
  22.1: 221,
  22.2: 223,
  22.3: 224,
  22.4: 225,
  22.5: 226,
  22.6: 227,
  22.7: 229,
  22.8: 230,
  22.9: 231.5,
  23: 233,
  23.1: 233.5,
  23.2: 234,
  23.3: 235,
  23.4: 236,
  23.5: 237,
  23.6: 238,
  23.7: 238.5,
  23.8: 239,
  23.9: 240,
  24: 241,
  24.1: 242,
  24.2: 243,
  24.3: 244,
  24.4: 245,
  24.5: 246,
  24.6: 247,
  24.7: 248,
  24.8: 249,
  24.9: 250.5,
  25: 252,
};
